import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Components from './components/components';
import HotTopicDetail from '../components/hotTopicDetail';

import './aiSecurity.less';
import './aiSecurity-en.less';
import './aiSecurity.theme.less';

export interface WhatsappProps {
  topicName: string;
  topicSettings: any[];
}

export function AiSecurity(props: WhatsappProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <HotTopicDetail
            settings={props.topicSettings}
            components={Components}
          />
        }
      />
    </Routes>
  );
}
